import type { EtapaGeracao } from '../types/baixarProcesso.types';

/**
 * As duas etapas são a MESMA espera pelo pacote — a pergunta "continuar esperando?" não para a
 * geração. Tudo o que vale para uma (bloqueio de novo pedido, aviso ao sair) vale para a outra.
 *
 * @example esperandoPacote('aguardandoDecisao') // true
 */
export function esperandoPacote(etapa: EtapaGeracao): boolean {
  return etapa === 'gerando' || etapa === 'aguardandoDecisao';
}

/**
 * Quanto o painel espera o pacote antes de perguntar se a pessoa quer continuar esperando.
 * Somado ao prazo da pergunta dá o "um minuto" que o painel promete ("Se a geração passar de um
 * minuto, terminamos em segundo plano e avisamos por e-mail").
 */
export const ESPERA_ANTES_DE_PERGUNTAR_MS = 30_000;

/** Prazo da pergunta "continuar esperando?": sem resposta, o painel pede o aviso por e-mail. */
export const PRAZO_DA_DECISAO_MS = 30_000;

/**
 * Milissegundos até `desde + duracao`, nunca negativo. Conta pelo relógio e não por ticks: aba em
 * segundo plano atrasa `setInterval`, mas o prazo continua sendo o do instante gravado.
 *
 * @example msAte('2026-10-01T10:00:00Z', 30_000, Date.parse('2026-10-01T10:00:10Z')) // 20000
 */
export function msAte(desde: string, duracaoMs: number, agoraMs: number): number {
  return Math.max(0, Date.parse(desde) + duracaoMs - agoraMs);
}

/**
 * Segundos inteiros que faltam até `ate` (arredonda para cima: o botão mostra "1s" até zerar).
 *
 * @example segundosRestantes('2026-10-01T10:00:30Z', Date.parse('2026-10-01T10:00:00.400Z')) // 30
 */
export function segundosRestantes(ate: string, agoraMs: number): number {
  return Math.ceil(msAte(ate, 0, agoraMs) / 1000);
}
